import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnRating as UIRating } from '@cainiaofe/cn-ui';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Rating',
    component: UIRating,
    formComponent: UIRating,
};
